<template>
  <component
    :is="element"
    class="button"
    :class="{
      'button--with-icon' : icon
    }"
    :aria-disabled="disableButton || null"
    :href="url || null"
    :type="type || null"
  >
    <span
      v-if="label"
      class="button__label"
      v-text="label"
    />

    <span
      v-if="icon"
      class="button__icon"
    >
      <component
        :is="icon"
        aria-hidden="true"
      />
    </span>
  </component>
</template>

<script>

/**
 * Component: button
 * ------------------------------------------------------------------------------
 * - Interactive button element
 * - Can be a link or button depending on target.
 * - Should be imported as <btn> as <button> already exists.
 * @param {Boolean} [disableButton] - Optionally disable the button.
 * @param {String} label - Button label.
 * @param {String} [type] - Type of button (button or submit).
 * @param {String} [url] - Optional URL, if the button is for a link.
 */
import IconCheck from '~icons/misc/check.svg'
import IconDown from '~icons/direction/down.svg'
import SizeGuide from '~icons/misc/size-guide.svg'
import IconQuickAdd from '~icons/misc/quick-add.svg'
import IconSpinner from '~icons/misc/spinner.svg'
import IconTick from '~icons/misc/tick.svg'
import IconAlert from '~icons/misc/alert.svg'

export default {
  name: 'Btn',

  components: {
    IconCheck,
    IconDown,
    SizeGuide,
    IconQuickAdd,
    IconSpinner,
    IconTick,
    IconAlert,
  },

  props: {
    disableButton: {
      type: [Boolean],
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: null,
    },
  },

  computed: {

    /**
     * Calculate the type of element the button is.
     * @returns {String}
     */
    element() {
      return this.url ? 'a' : 'button'
    },

    // icon() {
    //   return false
    // },
  },
}
</script>
